export function getEmptyGuid() {
  return '00000000-0000-0000-0000-000000000000';
}

export function isEmptyGuid(guid: string) {
  return guid === getEmptyGuid();
}
